import { render } from "./mapp.vue?vue&type=template&id=36750e78&scoped=true"
import script from "./mapp.vue?vue&type=script&lang=js"
export * from "./mapp.vue?vue&type=script&lang=js"

import "./mapp.vue?vue&type=style&index=0&id=36750e78&lang=scss&scoped=true"

import exportComponent from "/Users/vee/Desktop/git/web/bitcoooPcWebsite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36750e78"]])

export default __exports__